export const Ultra_Mobile = "https://ultramobile-teltik.azurewebsites.net/api";
export const Britex = "https://britex.pw/api";
export const code = "BxowiIVe9N6X1oTDptmz0meIB8jnLJzmrzvoXqb/PvQtSoLGaUHKFw";
